webpackJsonp([72535408073075],{

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  line-height: 1.75rem;\n  font-size: 1.25rem;\n  font-weight: 300;\n  ', '\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 20px;\n  }\n'], ['\n  line-height: 1.75rem;\n  font-size: 1.25rem;\n  font-weight: 300;\n  ', '\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 20px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionText = _styledComponents2.default.div(_templateObject, '' /* opacity: 0.9; */);
	
	exports.default = SectionText;
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0px 10px 20px;\n  flex: 0 1 45%;\n  width: 440px;\n  min-height: 225px;\n\n  @media (max-width: 900px) {\n    max-width: 800px;\n    flex: 0 1 100%;\n    margin: 0px 0px 20px;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n    })\n'], ['\n  margin: 0px 10px 20px;\n  flex: 0 1 45%;\n  width: 440px;\n  min-height: 225px;\n\n  @media (max-width: 900px) {\n    max-width: 800px;\n    flex: 0 1 100%;\n    margin: 0px 0px 20px;\n  }\n\n  @media (max-width: 600px) {\n    width: 100%;\n    })\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.25rem;\n  margin: 0px 0px 0.5rem;\n  opacity: 0.5;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.25rem;\n  margin: 0px 0px 0.5rem;\n  opacity: 0.5;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  margin: 0px 0px 1rem;\n  font-weight: 400;\n'], ['\n  line-height: 1.5rem;\n  margin: 0px 0px 1rem;\n  font-weight: 400;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-right: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  background: ', ';\n  color: white;\n'], ['\n  margin-right: 0.25rem;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  background: ', ';\n  color: white;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _Card = __webpack_require__(30);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	
	var Teaching_Item = function Teaching_Item(props) {
	  return _react2.default.createElement(
	    ClassCard,
	    null,
	    _react2.default.createElement(
	      ClassTitle,
	      null,
	      props.class.title
	    ),
	    _react2.default.createElement(
	      ClassInstitution,
	      null,
	      props.class.institution
	    ),
	    _react2.default.createElement(
	      ClassSemester,
	      null,
	      props.class.semester.map(function (sem, i) {
	        return _react2.default.createElement(
	          'span',
	          { key: i },
	          sem,
	          props.class.semester.length - 1 > i ? ', ' : ''
	        );
	      })
	    ),
	    props.class.courseType && props.class.courseType.map(function (c, i) {
	      return _react2.default.createElement(
	        ClassType,
	        { type: c, key: i },
	        c
	      );
	    })
	  );
	};
	
	exports.default = Teaching_Item;
	
	
	var ClassCard = _Card2.default.extend(_templateObject);
	
	// const ALink = styled.a`
	//   text-decoration: none;
	//   color: #333;
	//   &:hover {
	//     color: seagreen;
	//   }
	// `;
	
	var ClassTitle = _styledComponents2.default.h2(_templateObject2);
	
	var ClassInstitution = _styledComponents2.default.h3(_templateObject3);
	
	var ClassSemester = _styledComponents2.default.p(_templateObject4);
	
	var ClassType = _styledComponents2.default.span(_templateObject5, function (props) {
	  return props.type == 'Lecture' && 'steelblue' || props.type == 'Laboratory' && 'mediumpurple' || 'seagreen';
	});
	//
	// const ProjectDescription = styled.p`
	//   line-height: 1.5rem;
	//   margin: 0px 0px .5rem;
	//   opacity: 0.7;
	// `;
	
	// const RelavantPapers = styled.p`
	//   background: linear-gradient(rgba(251, 251, 251,1),rgba(255, 255, 255,1));
	//   padding: 10px 20px;
	//   margin: 10px 0px;
	//   color: seagreen;
	//   border: 1px solid #eee;
	//   border-left: 5px solid seagreen;
	// `;
	
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: center;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Teaching_Item = __webpack_require__(203);
	
	var _Teaching_Item2 = _interopRequireDefault(_Teaching_Item);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _SectionText = __webpack_require__(45);
	
	var _SectionText2 = _interopRequireDefault(_SectionText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var TeachingPage = function TeachingPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { minHeight: '100vh' } },
	    _react2.default.createElement(
	      _Container2.default,
	      { teaching: true },
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        { light: true },
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          { light: true },
	          'Teaching'
	        ),
	        _react2.default.createElement(_SectionText2.default, { dangerouslySetInnerHTML: { __html: marked(data.allContentfulPage.edges[0].node.mainText.body.body, { sanitize: true }) }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      { small: true, grey: true },
	      _react2.default.createElement(
	        _InnerContainer2.default,
	        null,
	        _react2.default.createElement(
	          _SectionHeader2.default,
	          null,
	          'Previous Courses'
	        ),
	        _react2.default.createElement(
	          FlexContainer,
	          null,
	          data.allContentfulPage.edges[0].node.additionalItems && data.allContentfulPage.edges[0].node.additionalItems.map(function (item, i) {
	            return _react2.default.createElement(_Teaching_Item2.default, { key: i, 'class': item });
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = TeachingPage;
	var query = exports.query = '** extracted graphql fragment **';
	
	var FlexContainer = _styledComponents2.default.div(_templateObject);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-teaching-js-800eb6549525a1b42d63.js